query GetGlobalSearch($query: String!, $limitPerType: Int) {
  globalSearch(query: $query, limitPerType: $limitPerType) {
    recordType
    recordId
    label
    extraData
  }
}
